/* eslint-disable react/prop-types */
import React from 'react';
import { Form } from 'react-bootstrap';

export const FormLabel = ({ label, required }) => (
  <Form.Label>
    {label}
    {required && <span className="text-danger ms-1">*</span>}
  </Form.Label>
);
